import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { cancelReferral } from '../../../actions/referralAction';
import CustomPortal from '../../commonComponents/CustomPortal';
import { UserType } from '../../../enums/UserType';
import { Colors } from '../../../themes/colors';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { FeatureFlagKeys } from '../../../constants/ff.posthog';

export const ActionComponent = ({ row }) => {
  const dispatch = useDispatch();
  const useReferralService = useFeatureFlag(FeatureFlagKeys.referralProgramRebuild, false);
  const [cancelTarget, setCancelTarget] = useState(null);
  const [showCancelReferralPopup, setShowCancelReferralPopup] = useState(false);

  // On the referral-service path, cancel is only meaningful on a legacy
  // office-to-office referral: the monolith endpoint it calls accepts only
  // office->office, and a rebuilt row has no `migratedFrom` for it to key
  // on. Off (monolith rows, no `program` field at all), the check this PR
  // added is skipped entirely, matching pre-PR `origin/development`.
  const shouldDisplayCancelButton =
    (!useReferralService || row?.program === 'legacy') &&
    row?.sender?.user_type === UserType.DNT &&
    row?.receiver?.user_type === UserType.DNT &&
    !row?.isCancelled;

  const isEmptyAction = !shouldDisplayCancelButton;

  return (
    <>
      <div
        className="col"
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          gap: 15,
        }}
      >
        {shouldDisplayCancelButton && (
          <span
            type="button"
            style={{
              margin: 4,
              cursor: 'pointer',
              fontSize: 16,
              fontWeight: '700',
              color: Colors.error_500,
            }}
            onClick={() => {
              setShowCancelReferralPopup(true);
              setCancelTarget(row);
            }}
          >
            Cancel
          </span>
        )}

        {isEmptyAction && '-'}
      </div>

      {showCancelReferralPopup && !!cancelTarget && (
        <CustomPortal
          title="Cancel Referral"
          // eslint-disable-next-line max-len
          text={`Are you sure you would like to cancel this referral between ${cancelTarget?.sender?.office_name} and ${cancelTarget?.receiver?.office_name}?`}
          textStyle={{ textAlign: 'center' }}
          submitText="Cancel Referral"
          cancelText="Back"
          leftButtonProps={{ style: { backgroundColor: '#808080' } }}
          rightButtonProps={{ style: { backgroundColor: '#E74C3C' } }}
          submitPressed={() => {
            const cancelId = useReferralService ? cancelTarget?.migratedFrom : cancelTarget?.id;
            dispatch(cancelReferral(cancelId));
            setShowCancelReferralPopup(false);
            setCancelTarget(null);
          }}
          cancelPressed={() => {
            setShowCancelReferralPopup(false);
            setCancelTarget(null);
          }}
        />
      )}
    </>
  );
};
